import React, { useState, useEffect } from "react";
import {
  Table,
  Form,
  Row,
  Col,
  notification,
  Card,
  Button,
  Select,
  Dropdown,
  Menu,
  Modal,
  Input,
  Empty,
  DatePicker,
  Checkbox,
  Collapse,
  Tooltip,
} from "antd";
import {
  TeamOutlined,
  EyeOutlined,
  CommentOutlined,
  MenuOutlined,
  UnorderedListOutlined,
  DeleteOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import { Link } from "react-router-dom";
import { Excel } from "antd-table-saveas-excel";
import commentService from "../../services/comment";
import formService from "../../services/form";
import TaskDetailsComponent from "../../components/taskDetails";
import DefaultLayout from "../../components/layout/DefaultLayout";
import Header from "../../components/header";
import { useMediaQuery } from "react-responsive";
import locationService from "./../../services/location";
import UserComponent from "./../../components/user";
import FormListComponent from "./../../components/serviceDeskFormList";
import taskService from "../../services/tasks";
import qaService from "../../services/qualityAssurance";
import departmentService from "../../services/department";
import styles from "./index.css";
import moment from "moment";

const { Panel } = Collapse;
const RequestDelete = () => {
  const dateFormat = "DD-MM-YYYY";
  const [searchForm2] = Form.useForm();
  const [searchForm] = Form.useForm();
  const [form] = Form.useForm();
  const [selectedForm, setSelectedForm] = useState(2);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalDataCount, setTotalDataCount] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(150);
  const [page, setPage] = useState(1);
  const [isUATModalVisible, setIsUATModalVisible] = useState(false);
  const [isTaskModalVisible, setIsTaskModalVisible] = useState(false);
  const [isSendQaModalVisible, setIsSendQaModalVisible] = useState(false);
  const [currentKey, setCurrentKey] = useState(null);
  const [currentLocation, setCurrentLocation] = useState(null);
  // const [formVisible, setFormVisible] = useState(false);
  const [taskId, setTaskId] = useState(false);
  const [edit, setEdit] = useState(true);
  const [formData, setFormData] = useState(null);
  const [locations, setLocations] = useState([]);
  const [taskStatus, setTaskStatus] = useState([]);
  const [departments, setDepartments] = useState(null);
  const [sortBy, setSortBy] = useState("id");
  const [sortOrder, setSortOrder] = useState("desc");
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedStartDate, setSelectedStartDate] = useState(null);
  const [selectedEndDate, setSelectedEndDate] = useState(null);
  const [visible, setVisible] = useState(false);

  const getTaskStatus = async () => {
    const response = await taskService.getTaskStatus();
    setTaskStatus(response.data);
  };

  const handleSendQa = async (values) => {
    try {
      setLoading(true);
      const response = await qaService.sendQaRequest(
        selectedForm,
        currentKey,
        values.users
      );
      setLoading(false);
      if (response.success) {
        notification.success({
          message: "Success",
          description: response.message,
        });
      } else {
        notification.error({
          message: "Error",
          description: response.message,
        });
      }
      form.resetFields();
      setIsSendQaModalVisible(false);
    } catch (error) {
      console.error("Error sending QA request:", error);
      setLoading(false);
      notification.error({
        message: "Error",
        description:
          error.response.data.message ||
          "There was an error sending the QA request.",
      });
    }
  };

  const handleDelete = async (rrr) => {
    Modal.confirm({
      title: "Are you sure you want to delete this record?",
      icon: <ExclamationCircleOutlined />,
      content: "This action cannot be undone.",
      okText: "Yes, Delete",
      okType: "danger",
      cancelText: "Cancel",
      onOk: async () => {
        try {
          setLoading(true);
          const response = await taskService.deleteForm(selectedForm, rrr.id);
          setLoading(false);
          if (response.success) {
            notification.success({
              message: "Success",
              description: response.message,
            });
            fetchData();
          } else {
            notification.error({
              message: "Error",
              description: response.message,
            });
          }
        } catch (error) {
          setLoading(false);
          notification.error({
            message: "Error",
            description:
              error?.response?.message ||
              "There was an error sending the Delete request.",
          });
        }
      },
    });
  };

  useEffect(() => {
    getTaskStatus();
  }, []);

  const handleSortChange = (pagination, filters, sorter) => {
    setSortOrder(sorter.order === "ascend" ? "asc" : "desc");
    setSortBy(sorter.field);

    serviceDesk(
      selectedForm,
      page,
      itemsPerPage,
      sorter.field,
      sorter.order === "ascend" ? "asc" : "desc"
    );
  };

  const handleTableChange = (pagination, filters, sorter) => {
    setSortOrder(sorter.order === "ascend" ? "asc" : "desc");
    setSortBy(sorter.field);
    serviceDesk(
      selectedForm,
      pagination.current,
      pagination.pageSize,
      sorter.field,
      sorter.order === "ascend" ? "asc" : "desc"
    );
  };

  const handleFormChange = (selectedValue) => {
    setSelectedForm(selectedValue);
    localStorage.setItem("selectedFormDR", selectedValue);
    console.log(selectedValue);
  };

  const serviceDesk = async (
    form,
    page = 1,
    itemsPerPage = 150,
    sortBy = "",
    sortOrder = ""
  ) => {
    try {
      setLoading(true);
      const response = await formService.serviceDesk(
        form,
        page,
        itemsPerPage,
        sortBy,
        sortOrder
      );

      setLoading(false);
      setData(response.data);
      setCurrentPage(response.meta.current_page);
      setTotalDataCount(response.meta.total);
      // setItemsPerPage(response.meta.per_page);
      setItemsPerPage(150);
      return response;
    } catch (error) {
      setLoading(false);
      console.error("Error fetching data:", error);
      // Handle error, display message to the user
      notification.error({
        message: "Error",
        description: "There was a problem fetching data from the server.",
      });
    }
  };
  const fetchData = async () => {
    let savedForm = localStorage.getItem("selectedFormDR");
    if (savedForm) {
      setSelectedForm(JSON.parse(savedForm));
      savedForm = JSON.parse(savedForm);
    } else {
      setSelectedForm(selectedForm);
      savedForm = selectedForm;
    }
    try {
      setLoading(true);
      const res = await serviceDesk(savedForm);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, [selectedForm]);

  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      fixed: useMediaQuery({ minWidth: 768 }) ? "left" : null,
      width: 40,
    },
    {
      title: "Sequence No",
      dataIndex: "sequence_no",
      key: "sequence_no",
      width: 120,
      fixed: useMediaQuery({ minWidth: 768 }) ? "left" : null,
      sorter: true,
    },
    {
      title: "Request Title",
      dataIndex: "request_title",
      key: "request_title",
      // width: 160,
      fixed: useMediaQuery({ minWidth: 768 }) ? "left" : null,
      sorter: true,
    },
    {
      title: "Task Initiated At",
      dataIndex: "task_initiated_at",
      key: "task_initiated_at",
      // width: 200,
      sorter: true,
    },
    {
      title: "Task Assigned At",
      dataIndex: "task_assigned_at",
      key: "task_assigned_at",
      sorter: true,
    },
    {
      title: "Task Approval At",
      dataIndex: "task_approval_at",
      key: "task_approval_at",
    },
    {
      title: "Start Date",
      dataIndex: ["task_assigned", "expected_start_time"],
      key: "task_assigned",
      sorter: true,
    },
    {
      title: "End Date",
      dataIndex: ["task_assigned", "expected_end_time"],
      key: "task_assigned",
      sorter: true,
    },
    {
      title: "Task Status",
      dataIndex: ["task_status", "name"],
      key: "task_status",
      sorter: true,
    },
    {
      title: "Approval Status",
      dataIndex: "status",
      key: "status",
    },
    {
      title: "Delete",
      key: "actions",
      width: 80,
      fixed: useMediaQuery({ minWidth: 768 }) ? "right" : null,
      render: (text, record) => (
        <Tooltip title="Delete">
          <DeleteOutlined
            onClick={() => handleDelete(record)}
            style={{ color: "red", cursor: "pointer" }}
          />
        </Tooltip>
      ),
    },
  ];

  const [visibleColumns, setVisibleColumns] = useState(() =>
    columns.map((column) => column.key)
  );
  const handleColumnToggle = (key) => {
    const updatedVisibleColumns = [...visibleColumns];

    if (visibleColumns.includes(key)) {
      const index = updatedVisibleColumns.indexOf(key);
      if (index > -1) {
        updatedVisibleColumns.splice(index, 1);
      }
    } else {
      updatedVisibleColumns.push(key);
    }

    setVisibleColumns(updatedVisibleColumns);

    try {
      localStorage.setItem(
        "visibleColumnsDeleteServiceDesk",
        JSON.stringify(updatedVisibleColumns)
      );
    } catch (error) {
      console.error("Error saving visibleColumns to local storage:", error);
    }
  };

  useEffect(() => {
    try {
      const savedVisibleColumns = localStorage.getItem(
        "visibleColumnsDeleteServiceDesk"
      );
      if (savedVisibleColumns) {
        setVisibleColumns(JSON.parse(savedVisibleColumns));
      }
    } catch (error) {
      console.error("Error loading visibleColumns from local storage:", error);
    }
  }, []);
  const menuu = {
    items: columns.map((column) => ({
      key: column.key,
      label: (
        <Checkbox
          className="mr-5"
          style={{ fontSize: "12px" }}
          onChange={() => handleColumnToggle(column.key)}
          checked={visibleColumns.includes(column.key)}
        >
          {column.title}
        </Checkbox>
      ),
    })),
  };

  return (
    <DefaultLayout>
      {!loading && (
        <Card>
          <FormListComponent
            onChange={handleFormChange}
            selectedFormId={selectedForm}
          />
        </Card>
      )}

      <Row gutter={[24, 24]}>
        <Col span={24}>
          <Card>
            {data.length > 0 ? (
              <div>
                <Dropdown
                  className="mr-10"
                  menu={menuu}
                  open={visible}
                  onOpenChange={(isVisible) => setVisible(isVisible)}
                  trigger={["click"]}
                >
                  <button // Replaced <a> with <button>
                    style={{
                      color: "black",
                      fontSize: "11px",
                      color: "gray",
                      background: "transparent", // Make button background transparent
                      border: "none", // Remove button border
                      padding: 0, // Remove default button padding
                      cursor: "pointer", // Set cursor to pointer
                    }}
                    onClick={(e) => e.preventDefault()}
                  >
                    <UnorderedListOutlined /> Columns
                  </button>
                </Dropdown>

                <Table
                  rowKey="id"
                  style={{ minHeight: "100vh" }}
                  virtual
                  scroll={{ x: 2000, y: 1000 }}
                  sticky={true}
                  columns={columns.filter((column) =>
                    visibleColumns.includes(column.key)
                  )}
                  // columns={columns}
                  onChange={handleTableChange}
                  dataSource={data}
                  // pagination={true}
                  pagination={{
                    showSizeChanger: false,
                    current: currentPage,
                    total: totalDataCount,
                    pageSize: itemsPerPage,
                  }}
                  loading={loading}
                  rowClassName={(record) => {
                    return record.task_assigned_at !== null
                      ? "task-assigned-row"
                      : "";
                  }}
                />
              </div>
            ) : (
              <Empty description="No record found." />
            )}
          </Card>
        </Col>
      </Row>
      <></>
    </DefaultLayout>
  );
};

export default RequestDelete;
